/* eslint-disable import/prefer-default-export */
export const SITES_URL = 'https://slot.tizeti.com/cnmaestro/Views/index.php';
